import { register } from '../../../JavaScript/Utils'

export const LeasingCalculator = (el: HTMLElement) => {
  let initTimeout: number|null = null;

  function init() {
    const path = el.dataset['path'] ?? null;
    const lang = el.dataset['lang'] ?? null;
    const companyCode = el.dataset['code'] ?? null;

    const enableTracking = (window.CookieFirst?.consent || {'performance': false})['performance'] ?? false;

    const calculatorNode = document.createElement('leasing-calculator');
    calculatorNode.setAttribute('path', path);
    calculatorNode.setAttribute('lang', lang);
    if (companyCode !== null) {
      calculatorNode.setAttribute('code', companyCode);
    }
    calculatorNode.setAttribute('track', enableTracking ? 'true' : 'false');

    console.log('Placing leasing calculator in page', {path, lang, companyCode, enableTracking});
    el.parentElement.replaceChild(calculatorNode, el);
  }

  if (window.CookieFirst) {
    init();
  } else {
    // fallback if cf_init is never triggered => ensure the calculator is still displayed after some seconds
    initTimeout = window.setTimeout(() => {
      init();
    }, 2000);
    window.addEventListener('cf_init', (ev) => {
      window.clearTimeout(initTimeout);
      init();
    });
  }
}

register('LeasingCalculator', LeasingCalculator)
